import React, { useContext } from "react";
import { DeviceSection } from "../../context/DeviceContext";
import { useTranslation } from "react-i18next";
const EndPage = () => {
  const { t } = useTranslation();
  const { ShowHideDeviceFunction } = useContext(DeviceSection);

  return (
    <>
      <p className="text-center text-muted w-50 mx-auto my-5">
        {t("شما دستگاه خود را با موفقیت اضافه کردید.")}
      </p>
      <span
        className="d-block submitBtn text-center text-white py-3 mx-auto cursor"
        onClick={() => ShowHideDeviceFunction("firstPage")}
      >
        {t("تائید")}
      </span>
    </>
  );
};

export { EndPage };
